import React from 'react';
import styled from 'styled-components';

const PaginationFiller = () => {
    const StyledFiller = styled.span`
      border: 1px solid ${props => props.theme.palette.blueGrey[200]};
      margin-left: -1px;
      padding: 0.6em 0.5em 0;
    `;

    return (
        <StyledFiller className='stolo-pager-notclickable'>...</StyledFiller>
    );
};

export default PaginationFiller;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PaginationFiller.js